import React from 'react';

import type { MenuItemProps, SubMenuProps } from './types';
import {
  MenuItemWrapper,
  SubMenuTitleWrapper,
  SubMenuWrapper,
} from './wrappers';
/**
 * SubMenu component
 */
export const SubMenu: React.FC<SubMenuProps> = ({
  id,
  style,
  className,
  title,
  children,
  isOpen,
  level,
  onTitleClick,
  ...rest
}) => (
  <SubMenuWrapper
    id={id}
    style={style}
    className={className}
    level={level}
    role="treeitem"
    aria-expanded={isOpen}
    {...rest}
  >
    <SubMenuTitleWrapper isOpen={isOpen} onClick={onTitleClick}>
      {title}
    </SubMenuTitleWrapper>
    <div role="group">{children}</div>
  </SubMenuWrapper>
);

/**
 * MenuItem component
 */
export const MenuItem: React.FC<MenuItemProps> = (props) => (
  <MenuItemWrapper {...props} role="menuitem" tabIndex={0} />
);
